import { FileText, Inbox, Gem, Radio, TrendingUp, Hash } from 'lucide-react'
import type { KeyMetrics } from './types'

interface Props {
  metrics: KeyMetrics
}

export function KeyMetricsCards({ metrics }: Props) {
  const cards = [
    {
      title: 'Total Reports',
      value: metrics.totalReports,
      icon: FileText,
      colorClass: 'text-teal-500'
    },
    {
      title: 'Total Items',
      value: metrics.totalItems,
      icon: Inbox,
      colorClass: 'text-blue-500'
    },
    {
      title: 'Total Gems',
      value: metrics.totalGems,
      icon: Gem,
      colorClass: 'text-amber-500'
    },
    {
      title: 'Avg Items/Report',
      value: metrics.avgItemsPerReport,
      icon: Hash,
      colorClass: 'text-purple-500'
    },
    {
      title: 'Trends Tracked',
      value: metrics.questionsWithTrends,
      icon: TrendingUp,
      colorClass: 'text-emerald-500'
    },
    {
      title: 'Active Streams',
      value: metrics.activeStreams,
      icon: Radio,
      colorClass: 'text-indigo-500'
    },
  ]

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((card) => (
        <div
          key={card.title}
          className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900/50 p-4"
        >
          <div className="flex items-center gap-2 mb-2">
            <card.icon className={`w-4 h-4 ${card.colorClass}`} />
            <span className="text-xs text-stone-500 dark:text-stone-400">{card.title}</span>
          </div>
          <div className="text-2xl font-semibold text-stone-900 dark:text-stone-100">
            {typeof card.value === 'number' ? card.value.toLocaleString() : card.value}
          </div>
        </div>
      ))}
    </div>
  )
}
